import React, { useState } from "react";
import axios from "axios";
import backgroundImage from "../assets/images/bg.png";
import logo from "../assets/images/logoadm.png";
import { MdEmail, MdLock } from "react-icons/md";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { FiEye, FiEyeOff } from "react-icons/fi";


const LoginPage = () => {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);


  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/user/log-in`,
        {
          username_or_email: email,
          password: password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response?.data?.data;

      if (response.status === 200 && data) {
        const { full_name, employee_id, token, role, outlet_id } = data;

        localStorage.setItem("full_name", full_name);
        localStorage.setItem("employee_id", employee_id);
        localStorage.setItem("token", token);
        localStorage.setItem("role", role);
        if (outlet_id) {
          localStorage.setItem("id_outlet", outlet_id);
        }

        setShowSuccessModal(true);
        setTimeout(() => {
          window.location.href = "/";
        }, 2000);
      } else {
        setError("Login gagal. Silakan periksa kredensial Anda.");
      }
    } catch (error) {
      console.error("Error saat login:", error);
      setError("Terjadi kesalahan saat login. Silakan coba lagi.");
    }
  };

  return (
    <div
      className="flex items-center justify-center"
      style={{
        width: "100vw",
        height: "100vh",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between px-6 md:px-20">
        <div className="md:w-1/2 text-center md:text-left">
          <img
            src={logo}
            alt="Djaya Medica Logo"
            className="mx-auto md:mx-0 w-85 h-auto mb-4"
          />
        </div>

        <div className="md:w-1/3 bg-white/20 backdrop-blur-lg rounded-2xl shadow-2xl p-8">
          <h2 className="text-3xl font-bold text-gray-800 text-center">
            Welcome Back 🙂
          </h2>
          <p className="mt-2 text-gray-600 text-sm text-center mb-6">
            <strong>Djaya Medica Dashboard</strong> memudahkan pengelolaan operasional apotek.
          </p>

          <form className="space-y-4" onSubmit={handleLogin}>
            {error && <p className="text-red-500 text-center">{error}</p>}

            {/* Email */}
            <div className="relative">
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Username or Email
              </label>
              <div className="flex items-center border rounded-lg bg-white shadow-sm focus-within:ring-2 focus-within:ring-green-400">
                <span className="px-3 text-gray-400">
                  <MdEmail />
                </span>
                <input
                  id="email"
                  type="email"
                  placeholder="Username"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-2 rounded-r-lg focus:outline-none bg-transparent"
                  required
                />
              </div>
            </div>

            <div className="relative">
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Password
              </label>
              <div className="flex items-center border rounded-lg bg-white shadow-sm focus-within:ring-2 focus-within:ring-green-400">
                <span className="px-3 text-gray-400">
                  <MdLock />
                </span>
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-2 rounded-r-lg focus:outline-none bg-transparent"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="px-3 text-gray-400 focus:outline-none"
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>
            <div className="flex items-center justify-between mt-2">
            <label className="flex items-center text-sm text-gray-700">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="mr-2 rounded"
              />
              Remember Me
            </label>
          </div>

            {/* Tombol Login */}
            <button
              type="submit"
              className="w-full flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold py-2 rounded-lg transition-all duration-200"
            >
              <AiOutlineCheckCircle className="text-lg" />
              Login
            </button>
          </form>
        </div>
      </div>

      {/* Modal Sukses */}
      {showSuccessModal && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center w-80 animate-bounceIn">
            <h3 className="text-lg font-semibold mb-2 text-green-600">
              <AiOutlineCheckCircle className="mx-auto text-3xl mb-2" />
              Login Berhasil!
            </h3>
            <p className="text-gray-600 mb-4">
              Anda akan dialihkan ke halaman utama...
            </p>
            <button
              onClick={() => setShowSuccessModal(false)}
              className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg transition"
            >
              Tutup
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPage;
